import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import { compose, withFormik, withHooks, withStores } from "enhancers";
import { get, isFunction, isString } from "lodash";
import appStore from "stores/appStore";
import { AppColor } from "theme/app-color";
import Button from "./Button";
import T from "./T";

const ModalComponent = ({
  isShow,
  title,
  children,
  cancelButtonLabel,
  okButtonLabel,
  disabled,
  fullWidth,
  maxWidth,
  onOk,
  onCancel,
  onClose,
  onDelete,
  hideFooter,
  hideCancelButton,
  okButtonType = "submit",
  okButtonVariant = "text",
  cancelButtonVariant = "text",
  okButtonColor,
  contentStyle,
  showTitleCloseButton = false,
  titleCloseIconColor = AppColor["Other/Success"],
  ...rest
}: any) => (
  <Dialog
    open={isShow}
    onClose={disabled ? undefined : onClose}
    fullWidth={fullWidth}
    maxWidth={maxWidth}
    {...rest}
  >
    <DialogTitle>
      {showTitleCloseButton ? (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ gap: 8 }}
        >
          <T
            variant="h4"
            color={AppColor["Text/Black"]}
            style={{ flex: 1, minWidth: 0 }}
          >
            {title}
          </T>
          <IconButton
            aria-label="close"
            edge="end"
            size="small"
            onClick={disabled ? undefined : onClose}
            style={{ flexShrink: 0, marginRight: -8 }}
          >
            <Close
              style={{
                width: 20,
                height: 20,
                color: titleCloseIconColor,
              }}
            />
          </IconButton>
        </Box>
      ) : (
        <T variant="h4" color={AppColor["Text/Black"]}>
          {title}
        </T>
      )}
    </DialogTitle>
    <DialogContent style={contentStyle}>
      {isString(children) ? (
        <DialogContentText style={{ whiteSpace: "pre-wrap" }}>
          {children}
        </DialogContentText>
      ) : isFunction(children) ? (
        children(rest)
      ) : (
        children
      )}
    </DialogContent>
    {!hideFooter ? (
      <DialogActions>
        {onCancel && !hideCancelButton && (
          <Button
            variant={cancelButtonVariant}
            onClick={onCancel}
            color="light"
            size="small"
            disabled={disabled}
            style={{
              marginRight: 16,
              color: AppColor["Text/Secondary"],
              minWidth: "70px",
            }}
          >
            {cancelButtonLabel}
          </Button>
        )}
        {onOk && (
          <Button
            type={okButtonType}
            variant={okButtonVariant}
            onClick={() => onOk(rest)}
            style={{
              color: okButtonColor,
              border: `1px solid ${okButtonColor}`,
              minWidth: "70px",
            }}
            size="small"
            disabled={disabled}
          >
            {okButtonLabel}
          </Button>
        )}
      </DialogActions>
    ) : null}
  </Dialog>
);

const enhancer = compose(
  withStores((stores: any, props: any) =>
    props.storeName ? get(stores, props.storeName) : {}
  ),
  withFormik({}),
  withHooks((props: any, hooks: any) => {
    const { storeName, dispatch, okButtonLabel, ...rest } = props;
    const { useEffect, useMemo } = hooks;

    const okButtonColor = useMemo(() => {
      if (props.okButtonColor) {
        return props.okButtonColor;
      }
      // if (
      //   ["ลบ", "ลบข้อมูล", "ปฏิเสธและแจ้งเหตุผล", "ออกจากระบบ"].includes(
      //     okButtonLabel
      //   )
      // ) {
      //   return "#F34336";
      // }
      // if (["ยืนยันการจองคิว", "ยืนยัน", "ปิด"].includes(okButtonLabel)) {
      //   return "#2296F3";
      // }
      return "primary";
    }, [props.okButtonColor]);

    useEffect(() => {
      if (!rest.isShow) {
        rest.resetForm();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rest.isShow, rest.resetForm]);

    return { ...rest, okButtonLabel, okButtonColor };
  })
);

const Modal = enhancer(ModalComponent);

Modal.open = appStore.openMainModal;
Modal.close = appStore.closeMainModal;
Modal.alert = appStore.openAlertModal;
Modal.confirm = appStore.openConfirmModal;
Modal.delete = appStore.openConfirmDeleteModal;

export default Modal;
